import { render, staticRenderFns } from "./BioPrimaryLink.vue?vue&type=template&id=bfda386a&scoped=true&"
import script from "./BioPrimaryLink.vue?vue&type=script&lang=js&"
export * from "./BioPrimaryLink.vue?vue&type=script&lang=js&"
import style0 from "./BioPrimaryLink.vue?vue&type=style&index=0&id=bfda386a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfda386a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
